import API from './index'
import AES from '../assets/commonjs/aes'
import { reject } from 'q';



class Login {

  params = {
    url: "/app_login",
    body: {
      userId: "",
      pwd: "",
      otp_key: ""
    }

  }

  log_in = () => {
    return API.postNode(this.params).then(data => {
      // console.log(this.params)
      let decData = data.data;
      decData = JSON.parse(AES.decrypt(decData))
      console.log(decData,'decdata')
      return decData
    }).catch(error => {
      console.log(error)
    })
  }

  checkAD(params) {
    //userId: "cochat",//固定值
    //check_user: ""//要验证的用户itcode
    return API.postCheck(params).then(reponse => {
      return  JSON.parse(AES.decrypt(reponse.data))
    }).catch(error => {
      console.log(error.message,'检查用户')
    })
  }
}

export default new Login()



// WEBPACK FOOTER //
// ./src/api/login.js